"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _SortingDropdown = _interopRequireDefault(require("@insided/destination/uikit/SortingDropdown"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formatCount = require("@insided/shared/utils/formatCount");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ActivityTopicsListHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ActivityTopicsListHeader, _Component);

  var _super = _createSuper(ActivityTopicsListHeader);

  function ActivityTopicsListHeader() {
    (0, _classCallCheck2.default)(this, ActivityTopicsListHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ActivityTopicsListHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          totalTopicsCount = _this$props.totalTopicsCount,
          onSortChange = _this$props.onSortChange,
          className = _this$props.className;
      return (0, _preact.h)("header", {
        className: (0, _classnames.default)('list__items--header', 'qa-list-menu', className)
      }, (0, _preact.h)(_phrase.default, {
        p: "Topic|Topics",
        m: "Forum",
        count: {
          value: totalTopicsCount.toString()
        },
        renderAsText: true
      }, function (phraseTopics) {
        return (0, _preact.h)("div", {
          className: "list__items--header-heading qa-thread-list-count"
        }, "".concat((0, _formatCount.formatCount)(totalTopicsCount), " ").concat(phraseTopics));
      }), totalTopicsCount > 1 && (0, _preact.h)(_phrase.default, {
        p: "sort.thread.lastpost.desc",
        m: "Common",
        renderAsText: true
      }, function (phraseLastPostSort) {
        return (0, _preact.h)(_phrase.default, {
          p: "sort.thread.dateline.desc",
          m: "Common",
          renderAsText: true
        }, function (phraseNewestSort) {
          return (0, _preact.h)(_phrase.default, {
            p: "sort.thread.replycount.desc",
            m: "Common",
            renderAsText: true
          }, function (phraseReplyCountSort) {
            return (0, _preact.h)(_phrase.default, {
              p: "sort.thread.views.desc",
              m: "Common",
              renderAsText: true
            }, function (phraseViewsSort) {
              return (0, _preact.h)(_SortingDropdown.default, {
                sortOptions: [{
                  sortType: 'lastActivityAt',
                  sortDirection: 'desc',
                  sortLabel: phraseLastPostSort
                }, {
                  sortType: 'publishedAt',
                  sortDirection: 'desc',
                  sortLabel: phraseNewestSort
                }, {
                  sortType: 'replyCount',
                  sortDirection: 'desc',
                  sortLabel: phraseReplyCountSort
                }, {
                  sortType: 'views',
                  sortDirection: 'desc',
                  sortLabel: phraseViewsSort
                }],
                onSortChange: onSortChange
              });
            });
          });
        });
      }));
    }
  }]);
  return ActivityTopicsListHeader;
}(_preact.Component);

exports.default = ActivityTopicsListHeader;